import React, { useState } from 'react';
import AWS from "aws-sdk";
import axios from 'axios';

export default function Wbcamti01form({ userfc, activeSection, setActiveSection }) {


    const initialFromData = {
        state: '',
        register_as: '',
        name: '',
        age: '',
        gender: '',
        weight: '',
        height: '',
        dob: '',
        mobile: '',
        email: '',
        address: '',
        district: '',
        pincode: '',
        ageCategory: '',
        weightCategory: '',
        bloodGroup: '',
        guardianMobile: '',
        uniformSize: '',
        Image: '',
        Aadhaar: '',
    }

    const [selectedImage, setSelectedImage] = useState(null);
    const [image, setcImage] = useState(null);
    const [selectedAadhaar, setSelectedAadhaar] = useState(null);
    const [aadhaarFile, setAadhaarFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [formData, setFormData] = useState(initialFromData);



    const wcat = {
        "Male": {
            "U-10": ["30 kg", "32 kg", "34 kg", "36 kg", "38 kg", "40 kg", "42 kg", "44 kg", "46 kg", "48 kg", "50 kg", "52 kg", "54 kg", "56 kg", "58 kg", "60 kg", "63.5 kg", "65 kg", "+71 kg"],
            "U-12": ["30 kg", "32 kg", "34 kg", "36 kg", "38 kg", "40 kg", "42 kg", "44 kg", "46 kg", "48 kg", "50 kg", "52 kg", "54 kg", "56 kg", "58 kg", "60 kg", "63.5 kg", "65 kg", "+71 kg"],
            "U-14": ["32 kg", "34 kg", "36 kg", "38 kg", "40 kg", "42 kg", "44 kg", "46 kg", "48 kg", "50 kg", "52 kg", "54 kg", "56 kg", "58 kg", "60 kg", "63.5 kg", "65 kg", "67 kg", "+71 kg"],
            "U-16": ["38 - 40 kg", "40 - 42 kg", "42 - 45 kg", "45 - 48 kg", "48 - 51 kg", "51 - 54 kg", "54 - 57 kg", "57 - 60 kg", "60 - 63.5 kg", "63.5 - 67 kg", "67 - 71 kg", "71 - 75 kg", "75 - 81 kg", "81 - 85 kg", "85 - 91 kg", "+91 kg"],
            "U-18": ["38 - 40 kg", "40 - 42 kg", "42 - 45 kg", "45 - 48 kg", "48 - 51 kg", "51 - 54 kg", "54 - 57 kg", "57 - 60 kg", "60 - 63.5 kg", "63.5 - 67 kg", "67 - 71 kg", "71 - 75 kg", "75 - 81 kg", "81 - 85 kg", "85 - 91 kg", "+91 kg"],
            "18+": ["45 kg", "48 kg", "51 kg", "54 kg", "57 kg", "60 kg", "63.5 kg", "67 kg", "71 kg", "76 kg", "81 kg", "86 kg", "91 kg", "96+ kg"]
        },
        "Female": {
            "U-10": ["30 kg", "32 kg", "34 kg", "36 kg", "38 kg", "40 kg", "42 kg", "44 kg", "46 kg", "48 kg", "50 kg", "52 kg", "54 kg", "56 kg", "58 kg", "60 kg", "63.5 kg", "65 kg", "+71 kg"],
            "U-12": ["30 kg", "32 kg", "34 kg", "36 kg", "38 kg", "40 kg", "42 kg", "44 kg", "46 kg", "48 kg", "50 kg", "52 kg", "54 kg", "56 kg", "58 kg", "60 kg", "63.5 kg", "65 kg", "+71 kg"],
            "U-14": ["32 kg", "34 kg", "36 kg", "38 kg", "40 kg", "42 kg", "44 kg", "46 kg", "48 kg", "50 kg", "52 kg", "54 kg", "56 kg", "58 kg", "60 kg", "63.5 kg", "65 kg", "67 kg", "+71 kg"],
            "U-16": ["36 - 38 kg", "38 - 40 kg", "40 - 42 kg", "42 - 45 kg", "45 - 48 kg", "48 - 51 kg", "51 - 54 kg", "54 - 57 kg", "57 - 60 kg", "60 - 63.5 kg", "63.5 - 67 kg", "67 - 71 kg", "71 - 75 kg", "75 - 81 kg", "81 - 85 kg", "85 - 91 kg", "+91 kg"],
            "U-18": ["36 - 38 kg", "38 - 40 kg", "40 - 42 kg", "42 - 45 kg", "45 - 48 kg", "48 - 51 kg", "51 - 54 kg", "54 - 57 kg", "57 - 60 kg", "60 - 63.5 kg", "63.5 - 67 kg", "67 - 71 kg", "71 - 75 kg", "75 - 81 kg", "81 - 85 kg", "85 - 91 kg", "+91 kg"],
            "18+": ["45 kg", "48 kg", "51 kg", "54 kg", "57 kg", "60 kg", "63.5 kg", "67 kg", "71 kg", "75 kg", "76 kg", "81 kg", "86 kg", "91 kg", "96+ kg"]
        },
    }


    const handleImageChange = (event) => {
        const file = event.target.files[0];
        const inputName = event.target.name;
        if (!file) return;
        if (inputName === "Image") {
            setcImage(file);
            const reader = new FileReader();
            reader.onloadend = () => setSelectedImage(reader.result);
            reader.readAsDataURL(file);
        } else if (inputName === "Aadhaar") {
            setAadhaarFile(file);
            const reader = new FileReader();
            reader.onloadend = () => setSelectedAadhaar(reader.result);
            reader.readAsDataURL(file);
        }
    };



    const handleSingleFileUpload = async (event, name) => {
        event.preventDefault()
        const hasSelection = name === "Image" ? !!image : !!aadhaarFile;
        if (!hasSelection) {
            alert(`Please select ${name} file first`)
            return;
        }
        setLoading(true)
        try {
            const fileToUpload = name === "Image" ? image : aadhaarFile;
            const link = await uploadToS3(fileToUpload);
            setFormData({
                ...formData,
                [name]: link,
            });
            if (name === "Image") {
                setSelectedImage(link);
            } else if (name === "Aadhaar") {
                setSelectedAadhaar(link);
            }
        } catch (error) {
            alert(`Error uploading ${name}`)
        } finally {
            setLoading(false)
        }
    };

    const uploadToS3 = async (file) => {
        const S3 = new AWS.S3({
            accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
            region: process.env.REACT_APP_AWS_REGION
        });



        const params = {
            Bucket: 'minf-uploads',
            Key: `KOTR2025/registration/${formData.register_as || 'unknown'}/${file.name}`,
            Body: file,
        };

        try {
            const data = await S3.upload(params).promise();
            return data.Location;
        } catch (error) {
            console.error("Error uploading file:", error);
            throw error;
        }
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'dob') {
            const dobDate = new Date(value);
            const today = new Date();
            let computedAge = today.getFullYear() - dobDate.getFullYear();
            if (today.getMonth() < dobDate.getMonth() || (today.getMonth() === dobDate.getMonth() && today.getDate() < dobDate.getDate())) {
                computedAge = computedAge - 1;
            }
            let computedAgeCategory = '';
            const isFighter = formData.register_as === 'FC' || formData.register_as === 'FN';
            if (!isFighter) {
                computedAgeCategory = '';
            } else if (computedAge < 10) {
                computedAgeCategory = 'U-10';
            } else if (computedAge < 12) {
                computedAgeCategory = 'U-12';
            } else if (computedAge < 14) {
                computedAgeCategory = 'U-14';
            } else if (computedAge < 16) {
                computedAgeCategory = 'U-16';
            } else if (computedAge < 18) {
                computedAgeCategory = 'U-18';
            } else {
                computedAgeCategory = '18+';
            }
            setFormData({
                ...formData,
                dob: value,
                age: computedAge,
                ageCategory: computedAgeCategory,
            });
            return;
        }

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();
        const newFormData = {
            ...formData,
            username: userfc.name
        }
        if (formData.Aadhaar && formData.Image) {
            try {
                await axios.post(
                    `${process.env.REACT_APP_MINF_LATEST_BAC_BASE}/api/users/submit-form/${userfc.userID}`,
                    newFormData
                );

                setMessage("Thanks for Registering")
                console.log(newFormData)
                setFormData(initialFromData)
                setLoading(false)

            } catch (error) {
                setMessage("Error")
            }
        } else {
            setLoading(false)
            alert("Please upload both Photo and Aadhaar before submitting.")
        }

    };

    return (
        <>
            <div className="min-h-screen w-full max-w-5xl mx-auto px-4">
                <form className="w-full" onSubmit={handleSubmit}>
                        {/* Registration Details Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5 md:p-6 mb-6">
                            <h2 className="text-xl font-semibold text-[#183557] mb-4">Registration Details</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">State *</label>
                                    <select
                                        className="appearance-none w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        name="state"
                                        value={formData.state}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select a State</option>
                                        <option>Andaman and Nicobar Islands</option>
                                        <option>Andhra Pradesh</option>
                                        <option>Arunachal Pradesh</option>
                                        <option>Assam</option>
                                        <option>Bihar</option>
                                        <option>Chandigarh</option>
                                        <option>Chhattisgarh</option>
                                        <option>Delhi</option>
                                        <option>Goa</option>
                                        <option>Gujarat</option>
                                        <option>Haryana</option>
                                        <option>Himachal Pradesh</option>
                                        <option>Jammu and Kashmir</option>
                                        <option>Jharkhand</option>
                                        <option>Karnataka</option>
                                        <option>Kerala</option>
                                        <option>Ladakh</option>
                                        <option>Madhya Pradesh</option>
                                        <option>Maharashtra</option>
                                        <option>Manipur</option>
                                        <option>Meghalaya</option>
                                        <option>Mizoram</option>
                                        <option>Nagaland</option>
                                        <option>Odisha</option>
                                        <option>Puducherry</option>
                                        <option>Punjab</option>
                                        <option>Rajasthan</option>
                                        <option>Sikkim</option>
                                        <option>Tamil Nadu</option>
                                        <option>Telangana</option>
                                        <option>Tripura</option>
                                        <option>Uttar Pradesh</option>
                                        <option>Uttarakhand</option>
                                        <option>West Bengal</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Register As *</label>
                                    <select
                                        className="appearance-none w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        name="register_as"
                                        value={formData.register_as}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Role</option>
                                        <option value="FN">Fighter - N</option>
                                        <option value="FC">Fighter - C</option>
                                        <option value="G">Guest</option>
                                        <option value="T">Team Head</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Personal Information Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5 md:p-6 mb-6">
                            <h2 className="text-xl font-semibold   text-[#183557] mb-4">Personal Information</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Name *</label>
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">D.O.B *</label>
                                    <input
                                        type="date"
                                        name="dob"
                                        value={formData.dob}
                                        onChange={handleChange}
                                        className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Gender *</label>
                                    <select
                                        className="appearance-none w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        name="gender"
                                        value={formData.gender}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Gender</option>
                                        <option>Male</option>
                                        <option>Female</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Age</label>
                                    <input
                                        type="number"
                                        name="age"
                                        value={formData.age}
                                        disabled
                                        className="w-full bg-gray-100 border-2 border-gray-300 text-gray-700 py-3 px-4 rounded cursor-not-allowed"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Competition Details - Only for fighters */}
                        {(formData.register_as === "FC" || formData.register_as === "FN") && (
                            <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5 md:p-6 mb-6">
                                <h2 className="text-xl font-semibold   text-[#183557] mb-4">Competition Details</h2>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">Weight *</label>
                                        <input
                                            type="number"
                                            name="weight"
                                            value={formData.weight}
                                            onChange={handleChange}
                                            className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                            required
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">Age Category</label>
                                        <select
                                            className="appearance-none w-full bg-gray-100 border-2 border-gray-300 text-gray-700 py-3 px-4 rounded cursor-not-allowed"
                                            name="ageCategory"
                                            value={formData.ageCategory}
                                            disabled
                                        >
                                            <option value="">{formData.ageCategory || 'Auto-calculated'}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">Weight Category *</label>
                                        <select
                                            className="appearance-none w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                            name="weightCategory"
                                            value={formData.weightCategory}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Select Category</option>
                                            {formData.ageCategory &&
                                                formData.gender &&
                                                wcat[formData.gender][formData.ageCategory].map((option, index) => (
                                                    <option key={index} value={option}>{option}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2">Height *</label>
                                        <input
                                            type="number"
                                            name="height"
                                            value={formData.height}
                                            onChange={handleChange}
                                            className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Address & Contact Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5 md:p-6 mb-6">
                            <h2 className="text-xl font-semibold   text-[#183557] mb-4">Address & Contact</h2>
                            <div className="mb-4">
                                <label className="block text-sm font-bold text-gray-700 mb-2">Address *</label>
                                <input
                                    type="text"
                                    name="address"
                                    value={formData.address}
                                    onChange={handleChange}
                                    className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                    required
                                />
                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">District *</label>
                                    <input
                                        type="text"
                                        name="district"
                                        value={formData.district}
                                        onChange={handleChange}
                                        className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Pincode *</label>
                                    <input
                                        type="text"
                                        name="pincode"
                                        value={formData.pincode}
                                        onChange={handleChange}
                                        className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Mobile *</label>
                                    <input
                                        type="tel"
                                        name="mobile"
                                        value={formData.mobile}
                                        onChange={handleChange}
                                        pattern="[0-9]{10}"
                                        className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        required
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2">Email *</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                    className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                    required
                                />
                            </div>
                        </div>

                        {/* Medical & Guardian Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5 md:p-6 mb-6">
                            <h2 className="text-xl font-semibold   text-[#183557] mb-4">Medical & Guardian</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Blood Group *</label>
                                    <select
                                        className="appearance-none w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        name="bloodGroup"
                                        value={formData.bloodGroup}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Blood Group</option>
                                        <option>A+</option>
                                        <option>A-</option>
                                        <option>B+</option>
                                        <option>B-</option>
                                        <option>AB+</option>
                                        <option>AB-</option>
                                        <option>O+</option>
                                        <option>O-</option>
                                    </select>
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-2">Guardian Mobile *</label>
                                    <input
                                        type="tel"
                                        name="guardianMobile"
                                        value={formData.guardianMobile}
                                        onChange={handleChange}
                                        pattern="[0-9]{10}"
                                        className="w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                        required
                                    />
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-2">Uniform Size *</label>
                                <select
                                    className="appearance-none w-full bg-white border-2 border-gray-300 text-gray-700 py-3 px-4 rounded focus:outline-none focus:border-[#183557]"
                                    name="uniformSize"
                                    value={formData.uniformSize}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="">Select Size</option>
                                    <option>XS</option>
                                    <option>S</option>
                                    <option>M</option>
                                    <option>L</option>
                                    <option>XL</option>
                                    <option>XXL</option>
                                    <option>XXXl</option>
                                </select>
                            </div>
                        </div>

                        {/* Loading overlay */}
                        {loading && (
                            <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50">
                                <div className="bg-white px-8 py-6 rounded-lg shadow-lg   font-semibold">Uploading…</div>
                            </div>
                        )}

                        {/* Uploads Section */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-100 p-5 md:p-6 mb-8">
                            <h2 className="text-xl font-semibold   text-[#183557] mb-4">Document Uploads</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* Photo Upload */}
                                <div className="flex flex-col items-center gap-4">
                                    <div className={`w-full border-2 border-dashed border-gray-300 rounded-lg overflow-hidden ${selectedImage ? 'h-40' : 'h-24'} cursor-pointer hover:border-[#183557] transition`}>
                                        <label htmlFor="Image" className="flex justify-center items-center h-full w-full cursor-pointer">
                                            {selectedImage ? (
                                                <img src={selectedImage} alt="Photo" className="w-full h-full object-contain" />
                                            ) : (
                                                <div className="text-center">
                                                    <p className="text-gray-600 font-medium">Photo</p>
                                                </div>
                                            )}
                                            <input
                                                type="file"
                                                name="Image"
                                                id="Image"
                                                accept="image/*"
                                                onChange={handleImageChange}
                                                className="hidden"
                                            />
                                        </label>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={(e) => handleSingleFileUpload(e, "Image")}
                                        className="w-full bg-gray-800 hover:bg-gray-900 text-white font-semibold py-2 rounded transition"
                                    >
                                        Upload Photo
                                    </button>
                                </div>

                                {/* Aadhaar Upload */}
                                <div className="flex flex-col items-center gap-4">
                                    <div className={`w-full border-2 border-dashed border-gray-300 rounded-lg overflow-hidden ${selectedAadhaar ? 'h-40' : 'h-24'} cursor-pointer hover:border-[#183557] transition`}>
                                        <label htmlFor="Aadhaar" className="flex justify-center items-center h-full w-full cursor-pointer">
                                            {selectedAadhaar ? (
                                                <img src={selectedAadhaar} alt="Aadhaar" className="w-full h-full object-contain" />
                                            ) : (
                                                <div className="text-center">
                                                    <p className="text-gray-600 font-medium">Aadhaar</p>
                                                </div>
                                            )}
                                            <input
                                                type="file"
                                                name="Aadhaar"
                                                id="Aadhaar"
                                                accept="image/*,.pdf"
                                                onChange={handleImageChange}
                                                className="hidden"
                                            />
                                        </label>
                                    </div>
                                    <button
                                        type="button"
                                        onClick={(e) => handleSingleFileUpload(e, "Aadhaar")}
                                        className="w-full bg-gray-800 hover:bg-gray-900 text-white font-semibold py-2 rounded transition"
                                    >
                                        Upload Aadhaar
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="flex justify-center mb-8">
                            <button
                                type="submit"
                                className="w-full md:w-1/2 bg-green-600 hover:bg-green-700 text-white font-bold text-lg py-4 rounded-lg transition"
                            >
                                Submit Registration
                            </button>
                        </div>
                    </form>

                {/* Success/Error Message Modal */}
                {message && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                        <div className="bg-white rounded-xl shadow-xl p-8 max-w-md w-full text-center">
                            <p className="text-lg font-semibold text-gray-800 mb-6">{message}</p>
                            <button
                                onClick={() => {
                                    setMessage("");
                                    if (message === "Thanks for Registering") {
                                        window.location.reload();
                                    }
                                }}
                                className={`w-full py-3 rounded-lg font-semibold transition ${message === "Thanks for Registering"
                                        ? "bg-green-600 hover:bg-green-700 text-white"
                                        : "bg-red-600 hover:bg-red-700 text-white"
                                    }`}
                            >
                                {message === "Thanks for Registering" ? "OKAY" : "RETRY"}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </>
    )

}
